import { useContext } from "react";
import { PatientSubscription } from "src/api/types";
import { PatientSubscriptionContext } from "./PatientSubscriptionsProvider";

export function usePatientSubscriptions<T>(
  selector: (subscriptions: PatientSubscription[]) => T
) {
  const patientSubscriptions = useContext(PatientSubscriptionContext);

  if (patientSubscriptions == null) {
    throw new Error(
      "usePatientSubscriptions is used outside of PatientSubscriptionsProvider"
    );
  }

  return selector(patientSubscriptions);
}
